export const VERSION_APP = '2.3.10';
export const HOME_DIR = '/';
export const SLOT_COUNT = 30;

export const ENV = {
    PROD: {
        API_BASE_URL1: 'https://script.google.com/macros/s/AKfycbx8zjJwF-MtUwHBkwVQ_HKhTZP4nuWjH0qulD6DIIbwmvkBZ2_SH2d8qvupkch5K60r/exec',
        API_BASE_URL2: 'https://script.google.com/macros/s/AKfycbxD3DMsfKbLIcNv_gkkMDP2Cou1fiWZ6DCMo_ubWk4BgEv8dMkEbFP1JO60Vz5vRAvZ/exec',
        API_BASE_URL3: 'https://script.google.com/macros/s/AKfycbxzPAR7wD1BjafrIgzQuUkCM0Z8s9EyNTbLTAiECP4YjktE8LHktcPXxNcmBa85Vpaz/exec',
        API_BASE_URL4: 'https://script.google.com/macros/s/AKfycbzdgT8PXyz8WgmRdBpAq-8REm0Y6Qs1HARFj-JfWPa-yHOGG_IjM4t9muCR-_TEJ2PLeg/exec',
        API_BASE_URL5: 'https://script.google.com/macros/s/AKfycbz6iFwuxZOKMSk6H3RNOuntmP3KN8w5Ag0Di7-hwALbw_ZX8oHYk3KORQxcoHLa20a4/exec',
        API_BASE_URL6: 'https://script.google.com/macros/s/AKfycbyhNHbyZWV909ecO8bQB6n_Md8TzfLAPjzntyRxTQ4M3wg0n-H2z7hauGtG6Hk1ypgZpg/exec',
        API_BASE_URL7: 'https://script.google.com/macros/s/AKfycbwkHuhMIohZZnw8wY63SucrzXqii0OhnJqbUGOFFWK2wXIDSNhDRxKEXkWjWgaX4_m1/exec',
        API_BASE_URL8: 'https://script.google.com/macros/s/AKfycbxhXKwfxh5om1N9cEqYFev2aaTcPD0jDngOOne_PaaxQ1h-5I0Bqn_qf3XAZKsTvLQy/exec',
        API_BASE_URL9: 'https://script.google.com/macros/s/AKfycbzMoGNVVQNORv7jxGLGJ6X5KLShYxnBlNe44iNYMWn1LbOEvMV8XbLkOqsOpCMSPuID/exec',
        API_BASE_URL10: 'https://script.google.com/macros/s/AKfycbz1xGojK6xqpdWQAMaiX8cHbHU8JwD4kNxPcHyV8r-lBe2RSnEj3IAk8M9mykrNhFEwhg/exec',
        API_BASE_URL11: 'https://script.google.com/macros/s/AKfycbzSPYS7xMrd6uRgwQv-3M746Cy1oi7s5hmH93pBannu7U3W7hCOl2nbkIfg-aFSLJ5Wvw/exec',
        API_BASE_URL12: 'https://script.google.com/macros/s/AKfycbyawrFa-XJXvQnXBdd9T_Q3trJQVsjpPx8eAfOufG0FLvUp4r27I_bFXM_42JstKr4m/exec',
        API_BASE_URL13: 'https://script.google.com/macros/s/AKfycbzc4NIdrioqc9eOqGnpy-iIHLqPxFvs7V72_9DwGMRmWZ8AvOkCgK7IObxCtcMRY7RBgw/exec',
        API_BASE_URL14: 'https://script.google.com/macros/s/AKfycbyCTW_ucKubw9Yd0-8gOZOGLltPWAiepUKheNCr0OoHqggjYsntbeKH7wlOeJpg1s46/exec',
        API_BASE_URL15: 'https://script.google.com/macros/s/AKfycbwy3WuJhXRfm_P_3cH3AjI-qsooHpsc6KFNtO9Enacge7veXBnz_FJwd5LNUR1KBZrA/exec',
        API_BASE_URL16: 'https://script.google.com/macros/s/AKfycbwkq-o-ozLZFFuIq1xd9bDw4wZxQWYRRYTF3sM_K-s2Wl21q_YmbJHIxW5CXZMUZJYk/exec',
        API_BASE_URL17: 'https://script.google.com/macros/s/AKfycbw29_APVK0NmdQWYIVdNOdrse0dgGbZwLlb_k0LMESbsalqssedRClvhwYki5BMA5qU/exec',
        API_BASE_URL18: 'https://script.google.com/macros/s/AKfycbwLogb2IYXCRcvBDBLxOZdaRLG5RrO105Cb9tmWwNyqcQcwNqcC5DW0n9cjD9T1mVp3/exec',
        API_BASE_URL19: 'https://script.google.com/macros/s/AKfycbx9HLnaPv8stwxvtuDCvogDErF6DsgOAGw4dfPGBSZZ9Uyzg1-eVWry3Y3ZcibloVJ9lQ/exec',
        API_BASE_URL20: 'https://script.google.com/macros/s/AKfycbzs61JUlkSp-4usNFUTw3kqhgV8y9rlgM_MtwowkgfjI9UAvhjZ8OwLPvPIDADkbncS/exec',
        API_BASE_URL21: 'https://script.google.com/macros/s/AKfycbyOxsC5z9GGEhjFub0a1HRTM8BbARgVisYn98Cl0dj2hxvdOela3zP484j1t7YLySbj/exec',
        API_BASE_URL22: 'https://script.google.com/macros/s/AKfycbyAHN2zRh91iGimZDwdyAapI1NSkz55l2-nZFyh-JrBRFq5Ryw5bfIibs9h-JPEUhsg/exec',
        API_BASE_URL23: 'https://script.google.com/macros/s/AKfycbydzZzo_SOvBsKDpClGPNymP9oIWdJiTbPV6jxlDnP2f3DFcb8gcdXVEqfe0elGNY1qrg/exec',
        API_BASE_URL24: 'https://script.google.com/macros/s/AKfycbzSLiYUJRWdAL39FbdR63rlGu8s3NiWRfkSW9eQXtg7K0FTXXtiq_rbPPt2V39wHLOCbQ/exec',
        API_BASE_URL25: 'https://script.google.com/macros/s/AKfycbx9_QN7h2BhPVYAt21NUPN4GL5Gf_ILKpDVZJrcqyAEaicAxwBRdUhNmPzaUfDqPIKg/exec',
        API_BASE_URL26: 'https://script.google.com/macros/s/AKfycbzLPvwOVfUROdIjdzIi99JiOovicVDHjlLmqnD6dk5Mwb_0TZG-EcGWQswkf4FO-zOPeg/exec',
        API_BASE_URL27: 'https://script.google.com/macros/s/AKfycbwVmK-lVcCv3KPNLaqwGQRFC4AcfJMJ12s14p7w_lpo0mylhTH0GrFvVD18fTyJONRibQ/exec',
        API_BASE_URL28: 'https://script.google.com/macros/s/AKfycbyZ66JGcupwxVXBgJI1nZ6OhjaLYdH6tkM4oxUT62WdILeyasIcFcZmJG6p1szalZqx/exec',
        API_BASE_URL29: 'https://script.google.com/macros/s/AKfycbzbG_EhFLvLGcsam5gF8qm9ADYyaQLvOXolB4G--mnKLH241X_mMTuw96QWlEBKKRt51w/exec',
        API_BASE_URL30: 'https://script.google.com/macros/s/AKfycbyLmbwTok2fgppMRwaOwW0yLGajzfiClJ5JecQHtN0dbeyO6I-BrUupcZpwq7w5-eSseQ/exec',
        LIFF_ID1: '2010908844-iDjOxb84',
        LIFF_ID2: '2010908844-iMl4eMPH',
        LIFF_ID3: '2010908844-I5gyFsPW',
        LIFF_ID4: '2010908844-FOvvAV1s',
        LIFF_ID5: '2010908844-MR937BIg',
        LIFF_ID6: '2010908844-PKc5dQLH',
        LIFF_ID7: '2010908844-DiFFy3fN',
        LIFF_ID8: '2010908844-wMSXm39n',
        LIFF_ID9: '2010908844-SDXaYEcz',
        LIFF_ID10: '2010908844-Izh9lT3W',
        LIFF_ID11: '2010908844-kOVcBcTJ',
        LIFF_ID12: '2010908844-mN16wv3v',
        LIFF_ID13: '2010908844-5RFH5sM3',
        LIFF_ID14: '2010908844-XKCweX2z',
        LIFF_ID15: '2010908844-866m1mrm',
        LIFF_ID16: '2010908844-ok9WPoLt',
        LIFF_ID17: '2010908844-zgr92Txq',
        LIFF_ID18: '2010908844-0v4KpYtj',
        LIFF_ID19: '2010908844-mZzFo32a',
        LIFF_ID20: '2010908844-QwAr9vaD',
        LIFF_ID21: '2010908844-mIOrBdeU',
        LIFF_ID22: '2010908844-DP0hwQZm',
        LIFF_ID23: '2010908844-YagxMXHp',
        LIFF_ID24: '2010908844-PbJerb6F',
        LIFF_ID25: '2010908844-g820CdSB',
        LIFF_ID26: '2010908844-JDOqYeJ8',
        LIFF_ID27: '2010908844-gtFSZJbj',
        LIFF_ID28: '2010908844-A7HDfJuU',
        LIFF_ID29: '2010908844-6sy0sPoW',
        LIFF_ID30: '2010908844-kfiVcCTo',
        FLEX_IMAGE1: 'https://theme.gachaponfunn.com/images/flex1.png',
        FLEX_IMAGE2: 'https://theme.gachaponfunn.com/images/flex2.png',
        FLEX_IMAGE3: 'https://theme.gachaponfunn.com/images/flex3.png',
        FLEX_IMAGE4: 'https://theme.gachaponfunn.com/images/flex4.png',
        FLEX_IMAGE5: 'https://theme.gachaponfunn.com/images/flex5.png',
        FLEX_IMAGE6: 'https://theme.gachaponfunn.com/images/flex6.png',
        FLEX_IMAGE7: 'https://theme.gachaponfunn.com/images/flex7.png',
        FLEX_IMAGE8: 'https://theme.gachaponfunn.com/images/flex8.png',
        FLEX_IMAGE9: 'https://theme.gachaponfunn.com/images/flex9.png',
        FLEX_IMAGE10: 'https://theme.gachaponfunn.com/images/flex10.png',
        FLEX_IMAGE11: 'https://theme.gachaponfunn.com/images/flex11.png',
        FLEX_IMAGE12: 'https://theme.gachaponfunn.com/images/flex12.png',
        FLEX_IMAGE13: 'https://theme.gachaponfunn.com/images/flex13.png',
        FLEX_IMAGE14: 'https://theme.gachaponfunn.com/images/flex14.png',
        FLEX_IMAGE15: 'https://theme.gachaponfunn.com/images/flex15.png',
        FLEX_IMAGE16: 'https://theme.gachaponfunn.com/images/flex16.png',
        FLEX_IMAGE17: 'https://theme.gachaponfunn.com/images/flex17.png',
        FLEX_IMAGE18: 'https://theme.gachaponfunn.com/images/flex18.png',
        FLEX_IMAGE19: 'https://theme.gachaponfunn.com/images/flex19.png',
        FLEX_IMAGE20: 'https://theme.gachaponfunn.com/images/flex20.png',
        FLEX_IMAGE21: 'https://theme.gachaponfunn.com/images/flex21.png',
        FLEX_IMAGE22: 'https://theme.gachaponfunn.com/images/flex22.png',
        FLEX_IMAGE23: 'https://theme.gachaponfunn.com/images/flex23.png',
        FLEX_IMAGE24: 'https://theme.gachaponfunn.com/images/flex24.png',
        FLEX_IMAGE25: 'https://theme.gachaponfunn.com/images/flex25.png',
        FLEX_IMAGE26: 'https://theme.gachaponfunn.com/images/flex26.png',
        FLEX_IMAGE27: 'https://theme.gachaponfunn.com/images/flex27.png',
        FLEX_IMAGE28: 'https://theme.gachaponfunn.com/images/flex28.png',
        FLEX_IMAGE29: 'https://theme.gachaponfunn.com/images/flex29.png',
        FLEX_IMAGE30: 'https://theme.gachaponfunn.com/images/flex30.png',
    }
}

export const CURRENT_ENV = ENV.PROD;
